var render = function render(){
  var _vm$data;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_vm.createAble ? _c('b-col', {
    staticClass: "mb-3 d-flex justify-content-end",
    attrs: {
      "lg": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": _vm.addData
    }
  }, [_vm._v("Add Data Internal Manpower")])], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('table', {
    staticClass: "w-100"
  }, [_c('thead', [_c('th', [_vm._v("Fullname")]), _c('th', [_vm._v("Job Title")]), _c('th', [_vm._v("Email Manpower")]), _c('th', [_vm._v("Phone Manpower")]), _vm.createAble ? _c('th') : _vm._e()]), _c('tbody', [_vm._l(_vm.data, function (item, index) {
    var _item$internal_name, _vm$optionsJabatan$fi, _vm$optionsJabatan$fi2, _item$internal_email, _item$internal_phone;
    return _c('tr', {
      key: index,
      staticClass: "bg-white"
    }, [_c('td', [item.isEdit ? [_c('b-input', {
      staticClass: "rounded-sm",
      model: {
        value: item.internal_name,
        callback: function callback($$v) {
          _vm.$set(item, "internal_name", $$v);
        },
        expression: "item.internal_name"
      }
    })] : [_vm._v(" " + _vm._s((_item$internal_name = item === null || item === void 0 ? void 0 : item.internal_name) !== null && _item$internal_name !== void 0 ? _item$internal_name : '-') + " ")]], 2), _c('td', [item.isEdit ? [_c('b-form-select', {
      staticClass: "rounded-sm",
      attrs: {
        "plain": "",
        "options": _vm.optionsJabatan
      },
      model: {
        value: item.internal_position_id,
        callback: function callback($$v) {
          _vm.$set(item, "internal_position_id", $$v);
        },
        expression: "item.internal_position_id"
      }
    })] : [_vm._v(" " + _vm._s((_vm$optionsJabatan$fi = (_vm$optionsJabatan$fi2 = _vm.optionsJabatan.find(function (el) {
      return (item === null || item === void 0 ? void 0 : item.internal_position_id) == el.value;
    })) === null || _vm$optionsJabatan$fi2 === void 0 ? void 0 : _vm$optionsJabatan$fi2.text) !== null && _vm$optionsJabatan$fi !== void 0 ? _vm$optionsJabatan$fi : '-') + " ")]], 2), _c('td', [item.isEdit ? [_c('b-input', {
      staticClass: "rounded-sm",
      model: {
        value: item.internal_email,
        callback: function callback($$v) {
          _vm.$set(item, "internal_email", $$v);
        },
        expression: "item.internal_email"
      }
    })] : [_vm._v(" " + _vm._s((_item$internal_email = item === null || item === void 0 ? void 0 : item.internal_email) !== null && _item$internal_email !== void 0 ? _item$internal_email : '-') + " ")]], 2), _c('td', [item.isEdit ? [_c('b-input', {
      staticClass: "rounded-sm",
      attrs: {
        "type": "number"
      },
      model: {
        value: item.internal_phone,
        callback: function callback($$v) {
          _vm.$set(item, "internal_phone", $$v);
        },
        expression: "item.internal_phone"
      }
    })] : [_vm._v(" " + _vm._s((_item$internal_phone = item === null || item === void 0 ? void 0 : item.internal_phone) !== null && _item$internal_phone !== void 0 ? _item$internal_phone : '-') + " ")]], 2), _vm.createAble ? _c('td', [_c('div', {
      staticClass: "d-flex"
    }, [_c('b-button', {
      staticClass: "mr-2",
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('onDelete', index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash m-0"
    })]), !item.isEdit ? _c('b-button', {
      attrs: {
        "variant": "outline-success",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          item.isEdit = true;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit m-0"
    })]) : _c('b-button', {
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          item.isEdit = false;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save m-0"
    })])], 1)]) : _vm._e()]);
  }), _vm._l(_vm.manPowers, function (item, index) {
    return _c('tr', {
      key: "new-data-".concat(index),
      staticClass: "bg-white"
    }, [_c('td', [_c('b-input', {
      staticClass: "rounded-sm",
      model: {
        value: item.internal_name,
        callback: function callback($$v) {
          _vm.$set(item, "internal_name", $$v);
        },
        expression: "item.internal_name"
      }
    })], 1), _c('td', [_c('b-form-select', {
      staticClass: "rounded-sm",
      attrs: {
        "plain": "",
        "options": _vm.optionsJabatan
      },
      model: {
        value: item.internal_position_id,
        callback: function callback($$v) {
          _vm.$set(item, "internal_position_id", $$v);
        },
        expression: "item.internal_position_id"
      }
    })], 1), _c('td', [_c('b-input', {
      staticClass: "rounded-sm",
      model: {
        value: item.internal_email,
        callback: function callback($$v) {
          _vm.$set(item, "internal_email", $$v);
        },
        expression: "item.internal_email"
      }
    })], 1), _c('td', [_c('b-input', {
      staticClass: "rounded-sm",
      attrs: {
        "type": "number"
      },
      model: {
        value: item.internal_phone,
        callback: function callback($$v) {
          _vm.$set(item, "internal_phone", $$v);
        },
        expression: "item.internal_phone"
      }
    })], 1), _c('td', {
      staticStyle: {
        "min-width": "100px"
      }
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('b-button', {
      staticClass: "mr-2",
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          _vm.manPowers = [];
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash m-0"
    })]), _c('b-button', {
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          _vm.$emit('onAdd', item), _vm.manPowers = [];
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save m-0"
    })])], 1)])]);
  })], 2)]), !((_vm$data = _vm.data) !== null && _vm$data !== void 0 && _vm$data.length) && !_vm.manPowers.length ? _c('div', {
    staticClass: "p-3 d-flex justify-content-center"
  }, [_c('img', {
    attrs: {
      "src": require('@/public/img/not-found-image.png'),
      "alt": "not-found-image",
      "width": "160",
      "height": "140"
    }
  })]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }